import { sleeper } from '@/lib/tools';

const initialSetting = {
  currency: 'usd',
  granularity: 'daily',
  category: 'service',

  // Chart type
  defaultChartType: 'stacked',

  // Range
  defaultRange: 'lastMonth',

  // Series
  defaultSeries: { service: [], account: [] },
  defaultSeriesCount: 5,
  nonGroupingSeriesCount: 5,

  // Total
  showTotal: true,
  totalColor: '#ff9800',
  totalStrokeType: 'solid-bullet',
  totalLineWidth: 2,

  // Others
  othersColor: '#009688',

  // Style
  scrollbar: true,
  animated: true,
  grouping: true,

  // Export
  exportDataType: 'csv',
  exportImageType: 'svg',
  exportPrefix: 'chart',

  // Datatable
  defaultTableRowsPerPage: 10,
};

export const state = {
  data: {},
  loading: {
    put: false,
  },
};

export const actions = {
  async fetch({ commit, dispatch }) {
    if (!localStorage.getItem('personal')) {
      // Save to Session Storage
      await dispatch('put', initialSetting);
    }

    // Load from Session Storage
    const req = JSON.parse(localStorage.getItem('personal'));

    // Commit
    commit('updatePersonalData', req);
    return Promise.resolve();
  },

  async put({ commit }, params) {
    commit('requestStart', { key: 'put' });
    await sleeper(1000);

    localStorage.setItem('personal', JSON.stringify(params));
    commit('requestSucceed', { key: 'put' });

    return Promise.resolve();
  },
};

export const mutations = {
  updatePersonalData(state, data) {
    state.data = data;
  },

  requestStart(state, { key }) {
    state.loading[key] = true;
  },

  requestSucceed(state, { key }) {
    state.loading[key] = false;
  },

  requestFailed(state, { key }) {
    state.loading[key] = false;
  },
};

export const getters = {
  getAllPersonalData(state) {
    return state.data ? state.data : {};
  },

  getPersonalData: state => key => {
    if (!key) return null;

    return state.data[key] ? state.data[key] : null;
  },
};
